module.exports = __webpack_public_path__ + "static/media/S (47).d18c7ec7.jpg";